import { useCallback } from "react";
import { useQueryClient } from "react-query";
import { useAppSelector } from "../../../Config/Hooks";
import { RootState } from "../../../Config/Store";
import useInterval from "../../../Shared/Hooks/useInterval";

export const BESS_DETAIL_QUERY_KEYS = [
    "bess-equipment-totalizers",
    "bess-soc",
    "bess-power",
    "bess-bms-soc",
    "bess-pcs-modules",
];

const rootKeyOf = (queryKey: unknown): string | undefined => {
    if (Array.isArray(queryKey)) {
        return typeof queryKey[0] === "string" ? queryKey[0] : undefined;
    }
    return typeof queryKey === "string" ? queryKey : undefined;
};

export const isBessDetailQueryKey = (queryKey: unknown): boolean => {
    const root = rootKeyOf(queryKey);
    return root != null && BESS_DETAIL_QUERY_KEYS.includes(root);
};

// RN1: o ciclo reaproveita o AlarmUpdateInterval já existente na plataforma. A tabela de Alarmes
// Ativos não entra aqui porque o componente compartilhado mantém o timer próprio dele — mesma
// cadência (AlarmUpdateInterval), montado em outro instante.
export const useBessDetailAutoRefresh = () => {
    const queryClient = useQueryClient();
    const alarmUpdateInterval = useAppSelector(
        (state: RootState) => state.userConfigurarion.alarmUpdateInterval
    );

    const refresh = useCallback(() => {
        const isBessDetailQuery = (query: { queryKey: unknown }) =>
            isBessDetailQueryKey(query.queryKey);

        // Um ciclo lento não deve empilhar sobre o tick seguinte: o axios tem timeout de 30s e o
        // intervalo tem piso de 10s. Mesma proteção que as telas de alarme fazem via `isLoading`.
        if (queryClient.isFetching({ predicate: isBessDetailQuery }) > 0) {
            return;
        }

        queryClient.refetchQueries({
            active: true,
            predicate: isBessDetailQuery,
        });
    }, [queryClient]);

    useInterval(refresh, alarmUpdateInterval);
};
